import classNames from 'classnames'
import React, { ComponentType, ReactNode } from 'react'

import { IconProps } from '../../icon/icon.js'

export interface ListProps {
    children: ReactNode
    className?: string
    icon?: ComponentType<IconProps>
    iconClassName?: string
    size?: 'small'
    type?: 'ordered' | 'icon' | 'unstyled'
}

export interface ListContext {
    icon?: ComponentType<IconProps>
    iconClassName?: string
}

export const ListContext = React.createContext<ListContext>({})

export const List = (props: ListProps): JSX.Element => {
    const className: string = classNames(
        'list',
        {
            [`list--type-${props.type}`]: !!props.type,
            [`list--size-${props.size}`]: !!props.size,
        },
        props.className,
    )

    const listContextValue: ListContext = {
        icon: props.icon,
        iconClassName: props.iconClassName,
    }

    const ListElement = props.type === 'ordered' ? 'ol' : 'ul'

    return (
        <ListContext.Provider value={listContextValue}>
            <ListElement className={className}>{props.children}</ListElement>
        </ListContext.Provider>
    )
}
